
export default {
  namespaced: true,
  state: {
    data: [],
    leads: [],
    id_pending: false,
    isModalVisible: false,
    computeCredits: 500,
    max: 1000,
    marks: [100, 500, 1000, 2500, 5000, 10000, 25000],
    file: false,
    fileState: 'default',
    fileCredits: 0,
    updateInfo: false,
    fileText: 'Verifying uploaded leads'
  },
  mutations: {
    clearData (state) {
      state.data = []
      state.leads = []
      state.id_pending = false
      state.isModalVisible = false
      state.computeCredits = 500
      state.max = 1000
      state.file = false
      state.fileState = 'default'
      state.fileCredits = 0
      state.fileText = 'Verifying uploaded leads'
    },
    changeUpdateInfo (state, val) {
      state.updateInfo = val
    },
    modalState (state, val) {
      if (val) {
        state.isModalVisible = true
      } else {
        state.isModalVisible = false
      }
    },
    setLeads (state, data) {
      state.leads = data
    },
    setPending (state, id) {
      state.id_pending = id
    },
    changeCredits (state, data) {
      var total = data['total']
      var value = data['value']
      var credits = [100, 500, 1000, 2500, 5000, 10000, 25000]
      if (value) {
        credits = state.marks
      }
      if (total > 25000) {
        credits = [100, 500, 1000, 2500, 5000, total]
        state.computeCredits = total
        state.max = total
      } else {
        for (var i = 0; i < credits.length; i++) {
          if (total < credits[i]) {
            if (i < 1) {
              state.computeCredits = credits[i]
            } else {
              state.computeCredits = total
              credits[i - 1] = total
            }
            break
          }
          if (i === credits.length) {
            state.computeCredits = total
            credits[i] = total
            state.max = total
          }
        }
      }
      state.marks = credits
    },
    changeMax (state, total) {
      state.max = total
    },
    setFileData (state, data) {
      state.file = data['file']
      state.fileState = data['state']
      state.fileCredits = data['credits']
      state.fileText = data['text']
    }
  },
  getters: {

  },
  actions: {
  }
}
